<template>
  <b-row v-if="dp">
    <b-col cols="12">
      <b-row>
        <b-col
          xl="10"
          lg="10"
          md="11"
          sm="10"
        >
          <b-alert
            show
            variant="primary"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="UserIcon"
              />
              <span class="ml-25">Datos personales</span>
            </div>
          </b-alert>
        </b-col>
        <b-col
          xl="2"
          lg="2"
          md="1"
          sm="2"
        >
          <datos-personales-update
            :id="id"
            :current="dp"
            class="mb-1"
            @update="updateDatosPersonales"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col
      sm="12"
      md="3"
      lg="3"
      xl="3"
    >
      <div class="mx-1 mb-1">
        <h5 class="text-capitalize mb-75">
          CURP:
        </h5>
        <b-card-text>
          {{ dp.curp }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          RFC:
        </h5>
        <b-card-text>
          {{ dp.rfc }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Fecha de Nacimiento:
        </h5>
        <b-card-text>
          {{ dp.fecha_nacimiento }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Edad:
        </h5>
        <b-card-text>
          {{ calculeAge(dp.fecha_nacimiento) }}
        </b-card-text>
        <h5 class="text-capitalize mb-75">
          Medio de informacion:
        </h5>
        <b-card-text>
          {{
            dp.medio_informacion ? dp.medio_informacion.descripcion : 'Sin dato'
          }}</b-card-text>
      </div>
    </b-col>
    <b-col cols="3">
      <h5 class="text-capitalize mb-75">
        Género:
      </h5>
      <b-card-text>
        {{ dp.sexo_descripcion ? dp.sexo_descripcion : dp.sexo.descripcion }}
      </b-card-text>

      <!-- v-if="dp.sexo.id === 2" -->
      <h5 class="text-capitalize mb-75">
        Matricula Cartilla Militar:
      </h5>
      <b-card-text>
        {{ dp.matricula_cartilla_militar || 'No aplica' }}
      </b-card-text>
      <h5 class="text-capitalize mb-75">
        Estado Civil:
      </h5>
      <b-card-text>
        {{ dp.estado_civil.descripcion }}
      </b-card-text>

      <h5 class="text-capitalize mb-75">
        Estatura:
      </h5>
      <b-card-text> {{ dp.estatura }} [cm] </b-card-text>
      <!-- </div> -->
    </b-col>
    <b-col md="3">
      <h5 class="text-capitalize mb-75">
        Nacionalidad:
      </h5>
      <b-card-text>
        {{
          dp.otra_nacionalidad
            ? dp.otra_nacionalidad
            : dp.nacionalidad.descripcion
        }}
      </b-card-text>
      <!-- <div v-if="datosNacimiento"> -->
      <h5 class="text-capitalize mb-75">
        País Nacimiento:
      </h5>
      <b-card-text> {{ dp.pais_nacimiento || 'No aplica' }}</b-card-text>
      <h5 class="text-capitalize mb-75">
        Estado Nacimiento:
      </h5>
      <b-card-text> {{ dp.estado_nacimiento || 'No aplica' }} </b-card-text>
      <h5 class="text-capitalize mb-75">
        Alcaldía Nacimiento:
      </h5>
      <b-card-text> {{ dp.alcaldia_nacimiento || 'No aplica' }}</b-card-text>
    </b-col>
    <b-col md="3">
      <h5 class="text-capitalize mb-75">
        Lengua Indígena:
      </h5>
      <b-card-text> {{ dp.lengua_indigena || 'No' }}</b-card-text>
      <h5 class="text-capitalize mb-75">
        Comunidad indigena:
      </h5>
      <b-card-text>
        {{
          dp.comunidad_indigena ? dp.comunidad_indigena.descripcion : 'Sin dato'
        }}</b-card-text>
      <h5 class="text-capitalize mb-75">
        Comunidad afrodescendiente:
      </h5>
      <b-card-text>
        {{
          dp.comunidad_afrodescendiente
            ? dp.comunidad_afrodescendiente.descripcion
            : 'Sin dato'
        }}</b-card-text>
      <h5 class="text-capitalize mb-75">
        Comunidad LGBTTI:
      </h5>
      <b-card-text>
        {{
          dp.comunidad_lgbttti ? dp.comunidad_lgbttti.descripcion : 'Sin dato'
        }}</b-card-text>
    </b-col>
  </b-row>
</template>

<script>
import {
  BAlert, BCol, BCardText, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import moment from 'moment'
import DatosPersonalesUpdate from './components/DatosPersonalesUpdate.vue'

export default {
  name: 'EstudiosPrebecario',
  directives: {
    Ripple,
  },
  components: {
    BAlert,
    BCol,
    BCardText,
    BRow,
    DatosPersonalesUpdate,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: [Object, Array],
      default: () => {},
    },
    datosNacimiento: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dp: null,
    }
  },
  computed: {
    calculeAge() {
      return fechaNacimiento => `${moment().diff(
        moment(fechaNacimiento).format('YYYY-MM-DD'),
        'years',
      )} AÑOS`
    },
  },
  mounted() {
    this.dp = { ...this.data }
  },
  methods: {
    updateDatosPersonales({ estadoCivil }) {
      this.dp.estado_civil = estadoCivil
    },
  },
}
</script>

<style></style>
